import { Button } from '@material-ui/core';
import { EmptyState } from '@backstage/core-components';
import { CatalogTableRow } from '@backstage/plugin-catalog';
import { ML_MODEL_TYPE, routes } from '../../lib/viva';
import { EntityChampionCell, EntityServingCell } from './cells';
import { modelColumns } from './columns';
import { TypedCatalogPage } from './TypedCatalogPage';

const columns = modelColumns<CatalogTableRow>({
  champion: row => <EntityChampionCell entity={row.entity} />,
  serving: row => <EntityServingCell entity={row.entity} />,
});

export const ModelsPage = () => (
  <TypedCatalogPage
    section="models"
    title="Модели"
    subtitle="ML-модели платформы: чемпион в реестре MLflow и сервинг в кластерах"
    kind="component"
    type={ML_MODEL_TYPE}
    columns={columns}
    withLifecycle
    create={{ title: 'Новая модель', to: routes.newModel }}
    support="Модель создаётся шаблоном «Новая ML-модель»; версии регистрирует золотой путь (ml-path), сервинг согласует ArgoCD по MR в viva/gitops."
    emptyContent={
      <EmptyState
        missing="data"
        title="Моделей пока нет"
        description="Создайте первую модель из шаблона «Новая ML-модель» — проект появится здесь после регистрации в каталоге."
        action={
          <Button variant="contained" color="primary" href={routes.newModel}>
            Новая модель
          </Button>
        }
      />
    }
  />
);
